export const PREFERENCES_SLICE_NAME = 'preferences';

export const PREFERENCES_LOAD_USER_PREFIX: string = `${PREFERENCES_SLICE_NAME}/loadUser`;
export const PREFERENCES_UNSUBSCRIBE_ALL_PREFIX: string = `${PREFERENCES_SLICE_NAME}/unsubscribeAll`;
export const PREFERENCES_UNSUBSCRIBE_PREFIX: string = `${PREFERENCES_SLICE_NAME}/unsubscribe`;
export const PREFERENCES_SUBSCRIBE_PREFIX: string = `${PREFERENCES_SLICE_NAME}/subscribe`;
export const PREFERENCES_INITIALIZATION_PREFIX: string = `${PREFERENCES_SLICE_NAME}/initialization`;
export const PREFERENCES_SEND_FROM_UI_PREFIX: string = `${PREFERENCES_SLICE_NAME}/sendItemFromUI`;
